import ChooseRoleComponent from "./chooseRole.component";

export default ChooseRoleComponent;
